import bi from 'shared/bi/bi';

import { getAllSettings } from 'shared/selectors/app-settings';
import { getChannelForWidget } from '@wix/wix-vod-shared/src/common/selectors/channels';
import { getVideosGroupedByIds } from 'shared/selectors/videos';
import { getMainVideoId } from '@wix/wix-vod-shared/src/widget/ui-selectors/selected-video-id';
import { getVideoSelectedEventParams } from 'shared/utils/bi/video-overlay-events-params';

import { SELECTED_VIDEO_ACTIONS } from 'widget/redux/client/actions/select-video';

export default {
  [SELECTED_VIDEO_ACTIONS.SET]: ({ sendBiEvent, state, action, previousState }) => {
    if (action.payload === previousState.selectedVideoId) {
      return;
    }

    bi.logWidgetSystem('video.select.requested');

    sendBiEvent(
      'widget.VidSelected.displayed',
      getVideoSelectedEventParams({
        appSettings: getAllSettings(state),
        channelData: getChannelForWidget(state),
        videoItem: getVideosGroupedByIds(state)[getMainVideoId(state)],
      })
    );
  },
};



// WEBPACK FOOTER //
// ./src/widget/redux/bi-middleware/bi-handlers/selected-video.js